<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";

export default {
    mixins: [Api, Sabit],
    props: ["DonemId","Birimler","BirimId"],
    components: {
        Loader
    },
    data() {
        return {
            Page: {
                PageNumber: "1",
                PageSize: "9999",
                PageDataSize: "1",
            },
            TableData: {},
            loading: true,
            DonemAdi: "",
            uri: "data:application/vnd.ms-excel;base64,",
            template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
            base64: function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            },
        };
    },
    watch: {
        DonemId(){
            this.Get();
        }


    },
    methods: {
        Get() {

                let Filter = "&DonemId=" + this.DonemId;
                if (this.BirimId!=null && this.BirimId!=""){
                    Filter = Filter + "&BirimId=" + this.BirimId;
                } 
                this.ActionsFilterGet({ Service: "StrRaporlama/GetIcKontrolVeriGiris", Page: this.Page, Filter: Filter }).then((res) => {
                this.TableData = res.Data;

                });

        },
        ExcelExport(table, name) {
            if (!table.nodeType) table = this.$refs.veriGiris;
            var html = table.innerHTML
            var ctx = { worksheet: name || 'Worksheet', table: html }
            var a = document.createElement('a');
            a.href = this.uri + this.base64(this.format(this.template, ctx));
            a.download = name + '.xls';
            a.click();
        },
        groupBy: function (array, key) {
            const result = {};
            array.forEach((item) => {
                if (!result[item[key]]) {
                    result[item[key]] = [];
                }
                result[item[key]].push(item);
            });
            return result;
        },
    },
    computed: {},
    created() {
        this.ActionsSingleGet({
                Service: "strperfdonem",
                Id: this.DonemId,
              }).then((res) => {
                this.DonemAdi = res.Data.Aciklama; 

      });

    },
};
</script>
<template>
       <Loader :loading="loading">
    <div>
        <div class="text-sm-end">
            <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                ExcelExport(
                    'Veri Giriş Durumları (Birim Bazlı)',
                    'Veri Giriş Durumları (Birim Bazlı)',
                )
            ">
                <i class="mdi mdi-file-export-outline me-1"></i>
                Excel'e Aktar
            </button>
        </div>
        <div ref="veriGiris" class="table-responsive">
            <div class="table-responsive">
                <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%">
                    <tr>
                        <td colspan="4" style="text-align: center;">
                            <div>
                                <h4>Veri Giriş Durumları (Birim Bazlı)</h4>
                            </div>
                        </td>
                    </tr>
                </table>
                <br>
               <table class="table table-borderless mb-0" style="border-collapse: collapse; width: 100%; text-align: center;">
                <thead>
                    <tr style="background-color: #2A3042; color:aliceblue">
                        <th colspan="4" >{{   DonemAdi }}</th>
                  
                    </tr>
                    <tr>
                        <th style="background-color: #2A3042; color:aliceblue">Birim Adı</th>
                        <th colspan="3" style="background-color: #2A3042; color:aliceblue">Veri Giriş Durumu</th>
                    </tr>
                </thead>
                <tbody v-for="(Data,index) in this.TableData" :key="index">
                    <tr >
                        <td>{{ Data.Birimadi }}</td>
                        <td colspan="3" >{{ Data.VeriGirisDurum }}</td>

                    </tr>
                </tbody>
               </table>
            </div>

        </div>
    </div>
</Loader>
</template>
